import { render, staticRenderFns } from "./UserCart.vue?vue&type=template&id=0b233f8a&scoped=true&lang=html"
import script from "./UserCart.vue?vue&type=script&lang=ts"
export * from "./UserCart.vue?vue&type=script&lang=ts"
import style0 from "./UserCart.vue?vue&type=style&index=0&id=0b233f8a&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b233f8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b233f8a')) {
      api.createRecord('0b233f8a', component.options)
    } else {
      api.reload('0b233f8a', component.options)
    }
    module.hot.accept("./UserCart.vue?vue&type=template&id=0b233f8a&scoped=true&lang=html", function () {
      api.rerender('0b233f8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserCart.vue"
export default component.exports